<template>
  <donut-chart-card
    :size="size"
    :title="title"
    :value="data"
    :init-total="total"
    :unit="unit"
    :isMoveWrite="isMoveWrite"
    :is-move-detail="!!projectId"
    :orientation="orientation"
    @detail="onClickDetail"
    @write="onClickWrite"
  ></donut-chart-card>
</template>

<script>
/* eslint-disable brace-style */
import DonutChartCard from '@/components/DonutChartCard'

export default {
  name: 'DonutChart01',
  components: {DonutChartCard},
  props: {
    dataType: 'detail' | 'field' | 'address' | 'field_cat1' | 'company' | 'project',
    size: String,
    reloadCount: Number,
    orientation: {
      type: "landscape" | "portrait",
      default: () => "portrait"
    },
    title: {
      type: String,
      default: () => "사업장 현황"
    },
    unit: {
      type: String,
      default: () => "개소"
    },
    fieldCode: {
      type: String,
      default: undefined,
    },
    graphId: {
      type: Number,
      default: () => 1
    },
  },
  computed: {
    projectId () {
      return this.$route.params.proj_id
    },
    isMoveWrite () {
      // if (Number(`${this.projectId}`) === 1) return false
      // else return true
      return true
    },
    getLevel() {
      const projects = this.$store.state.member.memberInfo.projects;
      if (projects) {
        for (const project of projects) {
          if (`${project.id}` === `${this.projectId}` && project.company.length > 0) {
            const path = project.company[0].pivot.company_path;
            return path.split("/").length - 1; // Level
          }
        }
      }
    },
  },
  watch: {
    dataType (/*value*/) {
      this.loadGraph()
    },
  },
  data () {
    return {
      data: [{label: '데이터 없음', value: 0}],
      total: '0',
      detailDataPromise: null,
    }
  },
  async mounted () {
    await this.loadDetailData();
    await this.loadGraph()
  },
  methods: {
    async loadDetailData() {
      // 이미 진행 중인 요청이 있다면 해당 Promise 반환
      if (this.detailDataPromise) {
        return this.detailDataPromise;
      }

      const currentYear = new Date().getFullYear();
      const currentMonth = new Date().getMonth() + 1;

      const cacheKey = `detail_01_${currentYear}_${currentMonth}_v01`;

      // 캐시에 저장되어 있으면, 캐시에서 불러온다
      const cachedSessionData = sessionStorage.getItem(cacheKey);
      if (cachedSessionData) {
        const cachedItem = JSON.parse(cachedSessionData);
        const now = new Date().getTime();
        // 1분 (1 * 60 * 1000 밀리초) 내의 캐시인지 확인
        if (cachedItem && cachedItem.timestamp && (now - cachedItem.timestamp < 60000)) {
          return cachedItem.data; // 캐시된 데이터 반환
        } else {
          sessionStorage.removeItem(cacheKey); // 만료된 캐시 제거
        }
      }

      // Promise 객체 생성 및 저장
      this.detailDataPromise = (async () => {
        try {
          // 전체 사업장 메타 정보를 조회한다
          // 메타에 저장된 "과" 정보를 불러오기 위해
          const metaResponse = await this.$store.dispatch('project/LOAD_FIELD_META', {
            perPage: 10000,
            metaKeys: ['com_name']
          });
          const fieldMetas = metaResponse.data || [];
          const comNameByFieldId = {};
          for (const fieldMeta of fieldMetas) {
            let comName = '기타';
            if (fieldMeta.metas && fieldMeta.metas.com_name) {
              comName = fieldMeta.metas.com_name;
            }
            comNameByFieldId[fieldMeta.id] = comName;
          }

          const fieldParams = {
            projectId: this.projectId,
            page: 1,
            perPage: 10000,
            simple: true,
            showAll: true,
          };
          if (this.projectId === '2') {
            fieldParams.code = 'workplace-insider';
          }
          const fieldResponse = await this.$store.dispatch('project/LOAD_FIELD_LIST', fieldParams);
          const fieldList = fieldResponse.data || [];

          const data = [];

          for (const field of fieldList) {
            const workEndAt = field.work_end_at;
            if (workEndAt) {
              const workEndDate = new Date(workEndAt);
              const today = new Date();
              today.setHours(0, 0, 0, 0); // 오늘 날짜의 시작 시간으로 설정
              
              if (workEndDate < today) {
                continue; // 종료 날짜가 오늘보다 이전인 경우 제외
              }
            }

            const fieldId = field.id;

            const comName = comNameByFieldId[Number(fieldId)];
            const foundRow = data.find((row) => row.label === comName);

            if (foundRow) {
              foundRow.count += 1;
            } else {
              data.push({label: comName, count: 1});
            }
          }

          // sessionStorage에 데이터와 타임스탬프 저장
          const itemToCache = { data, timestamp: new Date().getTime() };
          sessionStorage.setItem(cacheKey, JSON.stringify(itemToCache));

          return data;
        } finally {
          // 작업 완료 후 Promise 객체 초기화
          this.detailDataPromise = null;
        }
      })();

      return this.detailDataPromise;
    },
    async loadGraph () {
      const data = await this.loadDetailData()

      const rowSum = data.reduce((acc, row) => {
        return acc + row.count;
      }, 0);
      data.sort((a, b) => b.count - a.count);


      const list = [];
      let no = 1;

      for (const row of data) {
        list.push({
          label: row.label,
          value: row.count,
        });
        no += 1;

        if (no > 5) break;
      }

      this.data = list;
      this.total = rowSum;
    },
    onClickDetail () {
      const projectId = this.$route.params.proj_id
      const graphId = this.graphId
      if (projectId) {
        this.$router.push(`/project/${projectId}/graph-detail/${graphId}`)
      } else {
        this.$router.push(`/graph-detail/${graphId}`)
      }
    },
    onClickWrite () {
      const proj_id = this.$route.params.proj_id
      const boardId = `${this.boardId}`
      this.$router.push({name: 'write|tab', params: {proj_id, boardId}})
    }
  },
}
</script>

<style scoped>

</style>
